import apiService from "./apiService";

const emergencyService = {
        async sendDistressSignal(data){
            try{
                const response = await apiService.post(`emergency/send-distress`,data,true);
                return response.data;
            }
            catch(error){
               if (error.response && error.response.status === 503) {
                return {
                    success: false,
                    message: "You're making requests too frequently. Please wait a moment before trying again.",
                };
            }
            return { success: false, message: "An error occured while processing the request" };
            }
        },
         async getRecentReports(){
            try{
                const response = await apiService.get(`emergency/get-recent-incedents`,{},true);
                return response.data;
            }
            catch(error){
               if (error.response && error.response.status === 503) {
                return {
                    success: false,
                    message: "You're making requests too frequently. Please wait a moment before trying again.",
                };
            }
            return [];
            }
        },
        async dispatchTeams(payload){
            try{
                return (await apiService.post(`emergency/dispatch-teams`,payload,true)).data;
            }
            catch
            {
                return {success: false, message: 'An error occured while processing the request.'}
            }
        },
        async getInfo(id){
              try{
                const response = await apiService.get(`emergency/${id}/get-info`,{},true);
                return response.data;
            }
            catch(error){
               if (error.response && error.response.status === 503) {
                return {
                    success: false,
                    message: "You're making requests too frequently. Please wait a moment before trying again.",
                };
            }
            return null;
            }
        },
        async search(searchModel){
            try{
                const response = await apiService.get(`emergency/search-requests`,searchModel,true);
                return response.data;
            }
            catch{
                    return {emergencies: [], totalRows: 0};
            }
        },
        async relocateEmergencyPosition(id, position){
            try{
                const response = await apiService.put(`emergency/${id}/relocate-position`,position,true);
                return response.data;
            }
            catch{
                return { success: false, message: 'An error occured while processing the request.'};
            }
        },
        async changeEmergencyType(id,etype){
            try{
                return (await apiService.put(`emergency/${id}/${etype}/change-type`,{},true)).data;
            }
            catch{
                return {success: false, message: 'An error occured while processing the request.'}
            }
        },
        async addNotes(id,notes){
            try{
                return (await apiService.put(`emergency/${id}/add-notes`,{notes: notes},true)).data;
            }
            catch{
                return {success: false, message: 'An error occured while processing the request'}
            }
        }
}

export default emergencyService;